import { post } from '../../../../api/axios';
import { type ListData } from '../../../models/ListData';

export const list = <TItem extends object = object>(
  url: string,
  page: number = 0,
  perPage: number = 10,
  sort: string = 'id',
  direction: 'ASC' | 'DESC' = 'ASC',
  search: string = '',
  filter?: object,
  signal?: AbortSignal,
) => {
  return post<ListData<TItem>>(
    url,
    {
      page,
      per_page: perPage,
      sort,
      direction,
      search,
      filter,
    },
    { signal },
  );
};
